export default __webpack_public_path__ + "static/media/tree-num-three.9c8e9785.png";